export default function authHeader() {
  const user = JSON.parse(localStorage.getItem('auth_user'))

  const headers = {}

  if (user && user.accessToken) {
    headers.Authorization = 'Bearer ' + user.accessToken
  }

  const manager = localStorage.getItem('auth_role_manager')
  if (manager) {
    headers['X-Provider'] = manager
  }

  const employee = localStorage.getItem('auth_role_employee')
  if (employee) {
    headers['X-Employee'] = employee
  }

  return headers
}
